import React, { createContext } from 'react';

import { ValidationError } from 'yup';

import { AttachmentPreview } from 'lane-shared/types/attachment';

import { ThemeType } from '../types/Theme';
import { UserContentInteractionType } from '../types/UserContentInteraction';
import { ContentType } from '../types/content/Content';
import { SearchOptions } from '../types/filters/SearchOptions';
import { ReservableAvailabilityRange } from '../hooks/useReservableAvailabilityByRange';

export type ContentRendererBlockContextType = {
  sectionSearch?: SearchOptions;
  isVerificationEmailSent?: boolean;
  // pushed up by useReservableAvailability so ContentRenderer's submit-time
  // capacity check (M-03) can read real per-slot remaining capacity.
  reservableAvailabilityRanges?: ReservableAvailabilityRange[];
  // fallback capacity for slots with no bookings yet (sparse-interval API
  // returns no entry for them) — without this, getSlotAvailability can't
  // tell a fresh slot's real capacity, and the submit-time guard silently
  // never blocks it.
  maxQuantityPerSlot?: number;
};

export type ContentRendererContextType = {
  scrollRef: React.Ref<React.ReactNode>;
  loading: boolean;
  isRefreshing: boolean;
  disabled: boolean;
  submitAttempted: boolean;
  editMode: boolean;
  previewLanguage?: string;
  dataValidation: ValidationError;
  content: ContentType;
  interaction: UserContentInteractionType;
  blockContext: ContentRendererBlockContextType;
  updateBlockContext: (
    update: Partial<ContentRendererBlockContextType>
  ) => void;
  theme: ThemeType;
  onSubmit: () => Promise<void>;
  onLink: (link: any) => Promise<void>;
  onClick: (e: any) => void;
  onInteractionUpdated: (update: Partial<UserContentInteractionType>) => void;
  preventSubmission: boolean;
  hideSubmissionBlocks: boolean;
  submissionCompletedAt?: Date;
  draftAttachmentsCreate?: AttachmentPreview[];
  updateAttachmentsUCICreate?: (data: AttachmentPreview[]) => {};
};

const ContentRendererContext = createContext({} as ContentRendererContextType);

export default ContentRendererContext;
